import { render, staticRenderFns } from "./TeamRequestsDetailPage.vue?vue&type=template&id=c1f49572"
import script from "./TeamRequestsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsDetailPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports